import React, { FC, useCallback, useContext } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import TinyButton from '../widgets/TinyButton'
import useEditorActions from './useEditorActions'
import icons from '../../icons'

import EditorContext from './EditorContext'

import {
  ILayout,
} from '@kaidam/fc-shared/src/types/layout'

interface SaveButtonProps {
  title?: string,
  className?: string,
  onChange: {
    (data: ILayout): void,
  },
}

const SaveButton: FC<React.PropsWithChildren<SaveButtonProps>> = ({
  title,
  className,
  onChange,
}) => {

  const editorContext = useContext(EditorContext)

  const {
    exportLayout,
  } = useEditorActions()

  const onSave = useCallback(() => {
    onChange(exportLayout(editorContext.options))
  }, [
    onChange,
  ])
  
  return (
    <TinyButton
      className={ className }
      sx={{
        mr: 1,
      }}
      color="secondary"
      onClick={ onSave }
    >
      { title || 'Save' }
    </TinyButton>
  )

}

export default SaveButton